import { Breakpoints, styled } from '@volkswagen-onehub/components-core';
import { VWTheme } from '../../../../shared/typings/vw-theme';

export const StyledManageDealerInfoContainer: any = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledManageDealerAvailabilityContainer: any = styled.div`
  font-weight: ${(theme: VWTheme) => theme?.fonts?.headline[300] || '700'};
  color: ${(theme: VWTheme) => theme?.colors?.signal?.success || '#0F852F'};
`;

export const StyledManageDealerInformationItemContainer: any = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${(theme: VWTheme) => theme?.size?.static200 || '16px'};
  font-size: ${(theme: VWTheme) => theme?.size?.static200 || '16px'};
  color: ${(theme: VWTheme) => theme?.colors?.content?.tertiary || '#3C484D'};

  @media (min-width: ${Breakpoints.b1600}px) {
    font-size: ${(theme: VWTheme) => theme?.size?.static250 || '20px'};
  }
`;

export const StyledManageDealerInformationItemsContainer: any = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: ${(theme: VWTheme) => theme?.size?.static200 || '16px'};
`;


export const StyledManageDealerOpenClose = styled.div<{
  $closed?: boolean;
}>`
  ${({ theme, $closed = true }: { theme: VWTheme; $closed?: boolean }) => {
    return `color: ${$closed ? theme.colors.signal.error : theme.colors.signal.success};`;
  }}
`;
